import {
  Badge,
    Box,
    Button,
    Checkbox,
    Divider,
    Flex,
    Heading,
    IconButton,
    Image,
    SimpleGrid,
    Spacer,
    Stack,
    Step,
    StepDescription,
    StepIndicator,
    StepSeparator,
    StepStatus,
    StepTitle,
    Stepper,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    Text,
    Textarea,
  } from "@chakra-ui/react";
  import React, { useEffect, useRef, useState } from "react";
import { AddROSCall, FetchReviewSystemsDetails } from "../../middleware/services/messages";
import moment from "moment";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import { useLocation, useNavigate } from "react-router-dom";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import { DropdownInput, PrimaryButton, PrimaryInput, Toaster } from "../../components";
import DynamicModal from "../../components/dynamic-modal";
import { FetchDoctorsByUser } from "../../middleware/services/home";
import { formatDate_Do_MMM_YYYY_Time, getIsDoctor, getLoginID, uploadImageCommonFunction } from "../../auth";
import { useForm } from "react-hook-form";
import { CorrectChiefComplaintUsingAI } from "../../middleware/services/visits/aicalls";
import { useGPUTranscriber } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/useGPUTranscriber";
// import DatePicker from "../../components/date-picker";
import { GPUChatAudioManager } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/gpuChatVoiceManager";
import { DischargeSummaryLogs } from "../../middleware/services/prescriptions";
import DoctorCard from "../../components/doctor-card";
import { CopyIcon } from "@chakra-ui/icons";
import { CgRemove } from "react-icons/cg";
import { COLORS } from "../../components/styles/colors";
import { SaveSummaryCallLog } from "../../middleware/services/dischargesummarynotes";
import { getProfile } from "../../middleware/services/profile";
// import { Button } from "react-day-picker";

const DischargeSummaryIPD = ({id, backFunction}) => {

  const location = useLocation();
  const [patientid, setPatientid] = useState("");
  const [apmtIdUrl, setApmtIdUrl] = useState("");
  const [rosData, setRosData] = useState(null);
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const { showSuccessToast, showErrorToast } = Toaster();

  const previewModal = useRef(null);
  const audioPlayerRef = useRef(null);
const navigate = useNavigate();

  useEffect(() => {
    const currentUrl = window.location.href;
    const searchParams = new URLSearchParams(currentUrl.split('?') [1]);
    const id = searchParams.get('id');
    const apmtid = searchParams.get('appointmentid');
    setPatientid(id);

    if (apmtid) {
    setApmtIdUrl(apmtid);
  }

  getDoctorProfile();
  if(apmtid) {
      fetchDischargeLogs(id, apmtid)
    } else {
      fetchDischargeLogs(id, "")
    }
    // fetchDischargeLogs(id)   
  }, []);

  const [dischargeDisplaySettings, setDischargeDisplaySettings] = useState(null)
  const getDoctorProfile = async () => {
    showLoader();
    try {
      var result = await getProfile({});
      if (result && result.dischargesettingsdata) {
        // setShareReportDoctorEmail(result.ProfileOutput?.email);
        console.log('result.dischargesettingsdata:', result.dischargesettingsdata)
        setDischargeDisplaySettings(result.dischargesettingsdata)
      }
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile");
    } 
    // finally {
    //   dismissLoader();
    // }
  };

//   const handleIPDDataClick = () => {
//     setIpdClicked('IPD')
//     ipdTranscribeNotes.current.openModal();
//   };
  
  const fetchreviewsystemdata = async (id, apmtid="") => {
    showLoader()
        try {
          const result = await FetchReviewSystemsDetails({
            patientid: id,
            ...(apmtid && { appointmentid: apmtid }), 
            ...(apmtid && { type: 'ipd' })
          });

          // console.log(result, "pagessss review")

          if (result != null) {
            console.log(result)
            setRosData(result);
          } else {
            setRosData('')
          }
          dismissLoader()
      } catch (error) {
          console.error("Error in home:", error);
        }
      };

      const formatDate = (dateString) => {
        if (!dateString) return "-";
        return moment(dateString).format("Do MMM, YYYY");
      };

// -------------------------------------------------------------------
  // Discharge summary notes functionality start

  const [dischargeSummary, setDischargeSummary] = useState([]);

  const fetchDischargeLogs = async (id, apmtid="") => {
    showLoader();

    try {
      var result = await DischargeSummaryLogs({
        "doctorid": getLoginID(),
        ...(apmtid && { appointmentid: apmtid }), 
        ...(apmtid && { type: 'ipd' }),
        'patientid': id
      });
      if (result?.output?.data) {
        setDischargeSummary(result?.output?.data);
        // setAiDischargeResponse(result?.output?.data?.aiinput);
        // let count = result?.count;
        // let pageno = result?.pageno;
        // let pagesize = result?.pagesize;
        // setTotalItemCount(count)
        // let totalPagesCalc = count / pagesize;
        // let totalPagesCount = Math.ceil(totalPagesCalc);

        // setTotalPages(totalPagesCount);

        // setTotalItemCount(count)
        // if (result && result.count < itemPerPageCommonValue) {
        //   setCountTo(result.count)
        //   setTotalExceedsPageCount(true)
        // } else if (count > itemPerPageCommonValue && pageno == 1) {
        //   setCountTo(itemPerPageCommonValue);
        //   setTotalExceedsPageCount(false);
        // }

      } else {
        setDischargeSummary([])
      }
    } catch (error) {
      console.error("Error in home:", error);
    }
    dismissLoader();
  };
  // Discharge summary notes functionality end
  // -------------------------------------------------------------------
const [selectedTab, setSelectedTab] = useState("discharge");
const [aiDischargeResponse, setAiDischargeResponse] = useState(null);
const [shareChatSummary, setShareChatSummary] = useState(true);
  const [shareChatHistory, setShareChatHistory] = useState(true);
  const [shareDoctorNotes, setShareDoctorNotes] = useState(true);
  const [sharePatientHistory, setSharePatientHistory] = useState(true);


  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };
//   const aiLogPreview = (data) => {
//       setAiDischargeResponse(data?.aiinput)
//     console.log('data ailogview', data)
//   if(data) {
//     previewModal.current.openModal();
//   }
// }
const aiLogPreview = (data) => {
  console.log('data ailogview', data);
  if (data) {
    setAiDischargeResponse(data?.aiinput || data); // Set the data first
    // Use a timeout to ensure state is updated before opening modal
    setTimeout(() => {
      previewModal.current.openModal();
    }, 200);
  }
};

const [shareReportDoctorEmail, setShareReportDoctorEmail] = useState("");
const [editableSections, setEditableSections] = useState({
  patientInfo: '',
  admissionDetails: '',
  diagnosis: '',
  presentingComplaints: '',
  clinicalFindings: '',
  history: '',
  investigations: '',
  procedures: '',
  hospitalCourse: '',
  dischargeMeds: '',
  instructions: '',
  followUpPlan: ''
});

const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };
useEffect(() => {
  if (aiDischargeResponse) {
    setEditableSections({
      patientInfo: formatPatientInfo(aiDischargeResponse.patient_info),
      admissionDetails: `Admitted: ${aiDischargeResponse.admission_details.admitted_on!= "None" ? aiDischargeResponse.admission_details.admitted_on : ''}\nDischarged: ${aiDischargeResponse.admission_details.discharge_date!="None" ? aiDischargeResponse.admission_details.discharge_date : ""}`,
      // admissionDetails: `Admitted: ${aiDischargeResponse.admission_details.admitted_on}\nDischarged: ${aiDischargeResponse.admission_details.discharge_date}`,
      // diagnosis: aiDischargeResponse.diagnosis.final.join('\n'),
      diagnosis: aiDischargeResponse.diagnosis.final.filter(d => d && d !== 'None').join('\n'),
      presentingComplaints: formatComplaints(aiDischargeResponse.presenting_complaints),
      clinicalFindings: formatClinicalFindings(aiDischargeResponse.clinical_findings),
      history: formatHistory(aiDischargeResponse.history),
      investigations: formatInvestigations(aiDischargeResponse.investigations),
      procedures: formatProcedures(aiDischargeResponse.procedures),
      hospitalCourse: formatHospitalCourse(aiDischargeResponse.hospital_course),
      dischargeMeds: formatMedications(aiDischargeResponse.medications_on_discharge),
      instructions: formatInstructions(aiDischargeResponse.instructions),
      followUpPlan: formatFollowUpPlan(aiDischargeResponse.follow_up_plan)
    });
  }
}, [aiDischargeResponse]);

// const formatPatientInfo = (info) => {
//   return `Name: ${info.name== "None" ? "" : info.name}
// Age: ${info.age== "None" ? "" : info.age}
// Sex: ${info.sex== "None" ? "" : info.sex}
// UHID: ${info.uhid== "None" ? "" : info.uhid}
// Consultant: ${info.consultant== "None" ? "" : info.consultant}`;
// //   return `Name: ${info.name || ''}
// // Age: ${info.age || ''}
// // Sex: ${info.sex || ''}
// // UHID: ${info.uhid || ''}
// // Consultant: ${info.consultant || ''}`;
// };

const parsePatientInfo = (text) => {
  const lines = text.split('\n');
  const info = {
    name: '',
    age: '',
    sex: '',
    uhid: '',
    consultant: ''
  };
  
  lines.forEach(line => {
    if (line.includes('Name:')) info.name = line.replace('Name:', '').trim();
    if (line.includes('Age:')) info.age = line.replace('Age:', '').trim();
    if (line.includes('Sex:')) info.sex = line.replace('Sex:', '').trim();
    if (line.includes('UHID:')) info.uhid = line.replace('UHID:', '').trim();
    if (line.includes('Consultant:')) info.consultant = line.replace('Consultant:', '').trim();
  });
  
  return info;
};

// const formatComplaints = (complaints) => {
//   return complaints.map(c => `${c.description} - ${c.onset}`).join('\n');
// };
// const formatComplaints = (complaints) => {
//   const validComplaints = complaints.filter(c => c.description && c.description !== 'None');
//   return validComplaints.map(c => `${c.description} - ${c.onset || ''}`).join('\n');
// };

const parseComplaints = (text) => {
  return text.split('\n').filter(line => line.trim()).map(line => {
    const parts = line.split('-').map(p => p.trim());
    return {
      description: parts[0] || '',
      onset: parts[1] || ''
    };
  });
};

// const formatClinicalFindings = (findings) => {
//   let text = `General Condition: ${findings.general_condition || ''}\n\nVitals:\n`;
//   findings.vitals.forEach(vital => {
//     text += `- ${vital.name}: ${vital.value} ${vital.unit || ''}\n`;
//   });
//   text += `\nSystemic Exam:\n`;
//   findings.systemic_examination.forEach(exam => {
//     text += `- ${exam.system}: ${exam.finding}\n`;
//   });
//   return text;
// };
// const formatClinicalFindings = (findings) => {
//   let text = `General Condition: ${findings.general_condition== "None" ? '': findings.general_condition}\n\nVitals:\n`;
//   const validVitals = findings?.vitals?.filter(vital => vital.name && vital.name !== 'None');
//   validVitals.forEach(vital => {
//     text += `- ${vital.name}: ${vital.value || ''} ${vital.unit || ''}\n`;
//   });
//   if (validVitals.length === 0) text += ' \n';
  
//   text += `\nSystemic Exam:\n`;
//   const validExams = findings.systemic_examination.filter(exam => exam.system && exam.system !== 'None');
//   validExams.forEach(exam => {
//     text += `- ${exam.system}: ${exam.finding || ''}\n`;
//   });
//   if (validExams.length === 0) text += ' \n';
  
//   return text;
// };

const parseClinicalFindings = (text) => {
  const lines = text.split('\n');
  const findings = {
    general_condition: '',
    vitals: [],
    systemic_examination: []
  };

  let currentSection = '';
  
  lines.forEach(line => {
    if (line.includes('General Condition:')) {
      findings.general_condition = line.replace('General Condition:', '').trim();
    } else if (line.includes('Vitals:')) {
      currentSection = 'vitals';
    } else if (line.includes('Systemic Exam:')) {
      currentSection = 'systemic';
    } else if (line.startsWith('-') && currentSection === 'vitals') {
      const parts = line.replace('-', '').split(':').map(p => p.trim());
      if (parts.length >= 2) {
        const valueParts = parts[1].split(' ');
        findings.vitals.push({
          name: parts[0],
          value: valueParts[0],
          unit: valueParts.slice(1).join(' ') || ''
        });
      }
    } else if (line.startsWith('-') && currentSection === 'systemic') {
      const parts = line.replace('-', '').split(':').map(p => p.trim());
      if (parts.length >= 2) {
        findings.systemic_examination.push({
          system: parts[0],
          finding: parts[1]
        });
      }
    }
  });

  return findings;
};

// const formatHospitalCourse = (course) => {
//   let text = `Summary: ${course.summary || ''}\n\nInterventions:\n`;
//   course.interventions.forEach(int => {
//     text += `- ${int.name}: ${int.notes}\n`;
//   });
//   return text;
// };
// const formatHospitalCourse = (course) => {
//   // let text = `Summary: ${course.summary || ''}\n\nInterventions:\n`;
//   let text = `Summary: ${course.summary== "None" ? '': course.summary}\n\nInterventions:\n`;
//   const validInterventions = course.interventions.filter(int => int.name && int.name !== 'None');
//   validInterventions.forEach(int => {
//     text += `- ${int.name}: ${int.notes || ''}\n`;
//   });
//   if (validInterventions.length === 0) text += ' \n';
//   return text;
// };

const parseHospitalCourse = (text) => {
  const lines = text.split('\n');
  const course = {
    summary: '',
    interventions: []
  };

  let currentSection = '';
  
  lines.forEach(line => {
    if (line.includes('Summary:')) {
      course.summary = line.replace('Summary:', '').trim();
    } else if (line.includes('Interventions:')) {
      currentSection = 'interventions';
    } else if (line.startsWith('-') && currentSection === 'interventions') {
      const parts = line.replace('-', '').split(':').map(p => p.trim());
      if (parts.length >= 2) {
        course.interventions.push({
          name: parts[0],
          notes: parts[1]
        });
      }
    }
  });

  return course;
};

// const formatMedications = (meds) => {
//   return meds.map(med => 
//     `${med.name} ${med.dose || ''} ${med.frequency} ${med.route}`
//   ).join('\n');
// };
// const formatMedications = (meds) => {
//   const validMeds = meds.filter(med => med.name && med.name !== 'None');
//   return validMeds.map(med => 
//     `${med.name} ${med.dose || ''} ${med.frequency || ''} ${med.route || ''}`
//   ).join('\n');
// };

const parseMedications = (text) => {
  return text.split('\n').filter(line => line.trim()).map(line => {
    const parts = line.split(' ');
    return {
      name: parts[0] || '',
      dose: parts[1] || '',
      frequency: parts.slice(2, -1).join(' ') || '',
      route: parts[parts.length - 1] || ''
    };
  });
};

// const formatInstructions = (instructions) => {
//   let text = 'To Do:\n';
//   instructions.to_do.forEach(item => {
//     text += `- ${item}\n`;
//   });
//   text += '\nNot To Do:\n';
//   instructions.not_to_do.forEach(item => {
//     text += `- ${item}\n`;
//   });
//   return text;
// };
// const formatInstructions = (instructions) => {
//   let text = 'To Do:\n';
//   instructions.to_do.forEach(item => {
//     if (item && item !== 'None') text += `- ${item}\n`;
//   });
//   text += '\nNot To Do:\n';
//   instructions.not_to_do.forEach(item => {
//     if (item && item !== 'None') text += `- ${item}\n`;
//   });
  
//   // If no items in either section, just show headers
//   if (text === 'To Do:\n\nNot To Do:\n') {
//     // return 'To Do:\n- \nNot To Do:\n- ';
//     return 'To Do:\n \nNot To Do:\n ';
//   }
  
//   return text;
// };

const parseInstructions = (text) => {
  const lines = text.split('\n');
  const instructions = {
    to_do: [],
    not_to_do: []
  };

  let currentSection = '';
  
  lines.forEach(line => {
    if (line.includes('To Do:')) {
      currentSection = 'to_do';
    } else if (line.includes('Not To Do:')) {
      currentSection = 'not_to_do';
    } else if (line.startsWith('-')) {
      const item = line.replace('-', '').trim();
      if (currentSection === 'to_do') {
        instructions.to_do.push(item);
      } else if (currentSection === 'not_to_do') {
        instructions.not_to_do.push(item);
      }
    }
  });

  return instructions;
};

// const formatFollowUpPlan = (plan) => {
//   return `Follow up after: ${plan.follow_up_after_days && plan.follow_up_after_days == "None" ? '' : plan.follow_up_after_days + "Days"} 
// Location: ${plan.location== "None" ? '': plan.location}
// Doctor: ${plan.doctor== "None" ? '': plan.doctor}
// Contact: ${plan.contact== "None" ? '': plan.contact}`;
// // Location: ${plan.location || ''}
// // Doctor: ${plan.doctor || ''}
// // Contact: ${plan.contact || ''}`;
// };

const parseFollowUpPlan = (text) => {
  const lines = text.split('\n');
  const plan = {
    follow_up_after_days: '',
    doctor: '',
    location: '',
    contact: ''
  };

  lines.forEach(line => {
    if (line.includes('Follow up after:')) {
      plan.follow_up_after_days = line.replace('Follow up after:', '').replace('days', '').trim();
    } else if (line.includes('Location:')) {
      plan.location = line.replace('Location:', '').trim();
    } else if (line.includes('Doctor:')) {
      plan.doctor = line.replace('Doctor:', '').trim();
    } else if (line.includes('Contact:')) {
      plan.contact = line.replace('Contact:', '').trim();
    }
  });

  return plan;
};


// const formatHistory = (history) => {
//   let text = 'Personal History:\n';
//   history.personal_history.forEach(item => {
//     if (item !== 'None') text += `- ${item}\n`;
//   });
  
//   text += '\nPast Medical History:\n';
//   history.past_medical_history.forEach(item => {
//     if (item !== 'None') text += `- ${item}\n`;
//   });
  
//   text += '\nPast Surgical History:\n';
//   history.past_surgical_history.forEach(item => {
//     if (item !== 'None') text += `- ${item}\n`;
//   });
  
//   text += '\nChronic Medications:\n';
//   history.chronic_medications.forEach(item => {
//     if (item !== 'None') text += `- ${item}\n`;
//   });
  
//   return text;
// };
// const formatHistory = (history) => {
//   let text = 'Personal History:\n';
//   const personalItems = history.personal_history.filter(item => item && item !== 'None');
//   personalItems.forEach(item => {
//     text += `- ${item}\n`;
//   });
//   if (personalItems.length === 0) text += ' \n';
//   // if (personalItems.length === 0) text += '- \n';
  
//   text += '\nPast Medical History:\n';
//   const medicalItems = history.past_medical_history.filter(item => item && item !== 'None');
//   medicalItems.forEach(item => {
//     text += `- ${item}\n`;
//   });
//   if (medicalItems.length === 0) text += ' \n';
//   // if (medicalItems.length === 0) text += '- \n';
  
//   text += '\nPast Surgical History:\n';
//   const surgicalItems = history.past_surgical_history.filter(item => item && item !== 'None');
//   surgicalItems.forEach(item => {
//     text += `- ${item}\n`;
//   });
//   if (surgicalItems.length === 0) text += ' \n';
//   // if (surgicalItems.length === 0) text += '- \n';
  
//   text += '\nChronic Medications:\n';
//   const medItems = history.chronic_medications.filter(item => item && item !== 'None');
//   medItems.forEach(item => {
//     text += `- ${item}\n`;
//   });
//   if (medItems.length === 0) text += ' \n';
//   // if (medItems.length === 0) text += '- \n';
  
//   return text;
// };
const parseHistory = (text) => {
  const lines = text.split('\n');
  const history = {
    personal_history: [],
    past_medical_history: [],
    past_surgical_history: [],
    chronic_medications: []
  };

  let currentSection = '';
  
  lines.forEach(line => {
    if (line.includes('Personal History:')) {
      currentSection = 'personal';
    } else if (line.includes('Past Medical History:')) {
      currentSection = 'medical';
    } else if (line.includes('Past Surgical History:')) {
      currentSection = 'surgical';
    } else if (line.includes('Chronic Medications:')) {
      currentSection = 'meds';
    } else if (line.startsWith('-')) {
      const item = line.replace('-', '').trim();
      if (currentSection === 'personal') {
        history.personal_history.push(item);
      } else if (currentSection === 'medical') {
        history.past_medical_history.push(item);
      } else if (currentSection === 'surgical') {
        history.past_surgical_history.push(item);
      } else if (currentSection === 'meds') {
        history.chronic_medications.push(item);
      }
    }
  });

  return history;
};

// const formatInvestigations = (investigations) => {
//   return investigations.map(inv => 
//     `${inv.name}: ${inv.value} ${inv.unit || ''}`
//   ).join('\n');
// };
// const formatInvestigations = (investigations) => {
//   const validInvestigations = investigations.filter(inv => inv.name && inv.name !== 'None');
//   return validInvestigations.map(inv => 
//     `${inv.name}: ${inv.value || ''} ${inv.unit || ''}`
//   ).join('\n');
// };

const parseInvestigations = (text) => {
  return text.split('\n').filter(line => line.trim()).map(line => {
    const parts = line.split(':').map(p => p.trim());
    if (parts.length >= 2) {
      const valueParts = parts[1].split(' ');
      return {
        name: parts[0],
        value: valueParts[0],
        unit: valueParts.slice(1).join(' ') || ''
      };
    }
    return { name: '', value: '', unit: '' };
  });
};

// const formatProcedures = (procedures) => {
//   return procedures.map(proc => 
//     `${proc.name} - ${proc.date || ''}\n${proc.details || ''}`
//   ).join('\n\n');
// };
// const formatProcedures = (procedures) => {
//   const validProcedures = procedures.filter(proc => proc.name && proc.name !== 'None');
//   return validProcedures.map(proc => 
//     `${proc.name}${proc.date ? ` - ${proc.date}` : ''}${proc.details ? `\n${proc.details}` : ''}`
//   ).join('\n\n');
// };

const parseProcedures = (text) => {
  const procedureBlocks = text.split('\n\n');
  return procedureBlocks.filter(block => block.trim()).map(block => {
    const lines = block.split('\n');
    const firstLineParts = lines[0].split('-').map(p => p.trim());
    return {
      name: firstLineParts[0] || '',
      date: firstLineParts.length > 1 ? firstLineParts[1] : '',
      details: lines.slice(1).join('\n') || ''
    };
  });
};

const [updatedDownloadData, setUpdatedDownloadData] = useState(null);
const [downloadSummaryId, setDownloadSummaryId] = useState(null);
// const [dischargeSummary, setDischargeSummary] = useState(null);
const [docUrl, setDocUrl] = useState("");

// const handleSaveAll = async () => {
//   // Here you would process all the editableSections and save them
//   // For example:
//   showLoader();
//   const updatedDischargeResponse = {
//     ...aiDischargeResponse,
//     patient_info: parsePatientInfo(editableSections.patientInfo),
//     admission_details: {
//       admitted_on: editableSections.admissionDetails.match(/Admitted:\s*(.*)/)?.[1] || "",
//       discharge_date: editableSections.admissionDetails.match(/Discharged:\s*(.*)/)?.[1] || ""
//     },
//     diagnosis: {
//       ...aiDischargeResponse.diagnosis,
//       final: editableSections.diagnosis.split('\n')
//     },
//     presenting_complaints: parseComplaints(editableSections.presentingComplaints),
//     clinical_findings: parseClinicalFindings(editableSections.clinicalFindings),
//     history: parseHistory(editableSections.history),
//     investigations: parseInvestigations(editableSections.investigations),
//     procedures: parseProcedures(editableSections.procedures),
//     hospital_course: parseHospitalCourse(editableSections.hospitalCourse),
//     medications_on_discharge: parseMedications(editableSections.dischargeMeds),
//     instructions: parseInstructions(editableSections.instructions),
//     follow_up_plan: parseFollowUpPlan(editableSections.followUpPlan)
//   };
//   setUpdatedDownloadData(updatedDischargeResponse);

//   // console.log("Saving all data:", updatedDischargeResponse);
//   const input = {
//     'issingledocument': 1,
//     'aiinput': updatedDischargeResponse,
//   }
// //   if (isIPDDischarge) {
// //     input.appointmentid = appointmentId; 
// //     input.patientid = patientId;      
// //   }
//   console.log("Saving all data:", input);

//   try{
//     const result = await SaveSummaryCallLog(input);
//     if(result && result.output.result === 'Success') {
//       setDownloadSummaryId(result.output.id);
//       showSuccessToast("Discharge Summary Saved successfully");
//     }
//   } catch (error) {
//     console.error("API Error:", error);
//   }
//   dismissLoader();

// };

const downloadSummary = async () => {
  try {
    // Helper function to format sections
    const formatSection = (title, content) => {
      if (!content) return '';
      return `<h3>${title}</h3><p>${content.replace(/\n/g, "<br>")}</p>`;
    };

    // Parse the editable sections back to structured data
    const parsedData = {
      patient_info: parsePatientInfo(editableSections.patientInfo),
      admission_details: {
        admitted_on: editableSections.admissionDetails.match(/Admitted:\s*(.*)/)?.[1] || "",
        discharge_date: editableSections.admissionDetails.match(/Discharged:\s*(.*)/)?.[1] || ""
      },
      diagnosis: {
        final: editableSections.diagnosis.split('\n').filter(line => line.trim())
      },
      presenting_complaints: parseComplaints(editableSections.presentingComplaints),
      clinical_findings: parseClinicalFindings(editableSections.clinicalFindings),
      history: parseHistory(editableSections.history),
      investigations: parseInvestigations(editableSections.investigations),
      procedures: parseProcedures(editableSections.procedures),
      hospital_course: parseHospitalCourse(editableSections.hospitalCourse),
      medications_on_discharge: parseMedications(editableSections.dischargeMeds),
      instructions: parseInstructions(editableSections.instructions),
      follow_up_plan: parseFollowUpPlan(editableSections.followUpPlan)
    };

    let content = `<html>
      <head>
        <meta charset='utf-8'>
        <style>
          body { font-family: Arial, sans-serif; line-height: 1.6; text-align: left; }
          h1 { text-align: center; font-size: 20px; font-weight: bold; margin-bottom: 20px; }
          h3 { font-size: 16px; font-weight: bold; margin-top: 15px; }
          p { font-size: 14px; margin-left: 10px; }
          .section { margin-bottom: 20px; }
          table { width: 100%; border-collapse: collapse; margin: 10px 0; }
          th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
          th { background-color: #f2f2f2; }
        </style>
      </head>
      <body>
        <h1>Patient Discharge Summary Report</h1>`;

    // Patient Information
    content += formatSection('Patient Information', editableSections.patientInfo);

    // Admission Details
    content += formatSection('Admission Details', editableSections.admissionDetails);

    // Diagnosis
    content += formatSection('Diagnosis', editableSections.diagnosis);

    // Presenting Complaints
    if (parsedData.presenting_complaints?.length > 0) {
      const complaints = parsedData.presenting_complaints.map(c => 
        `${c.description} (onset: ${c.onset})`).join('<br>');
      content += formatSection('Presenting Complaints', complaints);
    }

    // Clinical Findings
    if (parsedData.clinical_findings) {
      let findings = `General Condition: ${parsedData.clinical_findings.general_condition}<br><br>`;
      
      findings += '<strong>Vitals:</strong><br>';
      findings += parsedData.clinical_findings.vitals.map(v => 
        `${v.name}: ${v.value} ${v.unit || ''}`).join('<br>');
      
      if (parsedData.clinical_findings.systemic_examination?.length > 0) {
        findings += '<br><br><strong>Systemic Examination:</strong><br>';
        findings += parsedData.clinical_findings.systemic_examination.map(e => 
          `${e.system}: ${e.finding}`).join('<br>');
      }
      
      content += formatSection('Clinical Findings', findings);
    }

    // History
    if (parsedData.history) {
      let historyText = '';
      if (parsedData.history.personal_history?.length > 0) {
        historyText += '<strong>Personal History:</strong><br>';
        historyText += parsedData.history.personal_history
          .filter(h => h !== 'None')
          .join('<br>') + '<br><br>';
      }
      
      if (parsedData.history.past_medical_history?.length > 0) {
        historyText += '<strong>Past Medical History:</strong><br>';
        historyText += parsedData.history.past_medical_history
          .filter(h => h !== 'None')
          .join('<br>') + '<br><br>';
      }
      
      if (parsedData.history.past_surgical_history?.length > 0) {
        historyText += '<strong>Past Surgical History:</strong><br>';
        historyText += parsedData.history.past_surgical_history
          .filter(h => h !== 'None')
          .join('<br>') + '<br><br>';
      }
      
      if (parsedData.history.chronic_medications?.length > 0) {
        historyText += '<strong>Chronic Medications:</strong><br>';
        historyText += parsedData.history.chronic_medications
          .filter(h => h !== 'None')
          .join('<br>');
      }
      
      content += formatSection('History', historyText);
    }

    // Investigations
    if (parsedData.investigations?.length > 0) {
      const investigations = parsedData.investigations.map(i => 
        `${i.name}: ${i.value} ${i.unit || ''}`).join('<br>');
      content += formatSection('Investigations', investigations);
    }

    // Procedures
    if (parsedData.procedures?.length > 0) {
      const procedures = parsedData.procedures.map(p => 
        `${p.name}${p.date ? ` (${p.date})` : ''}${p.details ? `<br>${p.details}` : ''}`)
        .join('<br><br>');
      content += formatSection('Procedures', procedures);
    }

    // Hospital Course
    if (parsedData.hospital_course) {
      let courseText = parsedData.hospital_course.summary;
      if (parsedData.hospital_course.interventions?.length > 0) {
        courseText += '<br><br><strong>Interventions:</strong><br>';
        courseText += parsedData.hospital_course.interventions.map(i => 
          `${i.name}: ${i.notes}`).join('<br>');
      }
      content += formatSection('Hospital Course', courseText);
    }

    // Discharge Medications
    if (parsedData.medications_on_discharge?.length > 0) {
      const medsTable = `
        <table>
          <thead>
            <tr>
              <th>Medication</th>
              <th>Dose</th>
              <th>Frequency</th>
              <th>Route</th>
            </tr>
          </thead>
          <tbody>
            ${parsedData.medications_on_discharge.map(med => `
              <tr>
                <td>${med.name}</td>
                <td>${med.dose || 'N/A'}</td>
                <td>${med.frequency}</td>
                <td>${med.route}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>`;
      content += `<div class="section"><h3>Discharge Medications</h3>${medsTable}</div>`;
    }

    // Instructions
    if (parsedData.instructions) {
      let instructionsText = '';
      if (parsedData.instructions.to_do?.length > 0) {
        instructionsText += '<strong>To Do:</strong><br>';
        instructionsText += parsedData.instructions.to_do.join('<br>') + '<br><br>';
      }
      if (parsedData.instructions.not_to_do?.length > 0) {
        instructionsText += '<strong>Not To Do:</strong><br>';
        instructionsText += parsedData.instructions.not_to_do.join('<br>');
      }
      content += formatSection('Instructions', instructionsText);
    }

    // Follow Up Plan
    if (parsedData.follow_up_plan) {
      const followUp = `
        Follow up after: ${parsedData.follow_up_plan.follow_up_after_days || 'N/A'} days<br>
        Location: ${parsedData.follow_up_plan.location || 'N/A'}<br>
        Doctor: ${parsedData.follow_up_plan.doctor || 'N/A'}<br>
        Contact: ${parsedData.follow_up_plan.contact || 'N/A'}`;
      content += formatSection('Follow Up Plan', followUp);
    }

    content += `</body></html>`;

    // Create and trigger download
    const encodedContent = encodeURIComponent(content);
    const a = document.createElement("a");
    a.href = "data:application/msword;charset=utf-8," + encodedContent;
    a.download = "discharge-summary.doc";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    // if(isIPDDischarge) {
      navigate('/ipdpatients')
    // } else {
    //   navigate('/home');
    // }
    // const getDischargeSetting = localStorage.getItem('saveDischarge');
    // if(getDischargeSetting == 1) {
      try {
        showLoader();
        
        // First upload the document
        const blob = new Blob([content], { type: 'application/msword' });
        const file = new File([blob], 'discharge-summary.doc', { type: 'application/msword' });
        
        const uploadResponse = await uploadImageCommonFunction(file, 'discharge-summary.doc');
        
        if (!uploadResponse || !uploadResponse.name) {
          throw new Error("Failed to upload document");
        }
        
        const documenturl = uploadResponse.name;
        setDocUrl(documenturl);

        // Then make the API call to save the summary
        const input = {
          'id': downloadSummaryId,
          'downloadedpdf': documenturl,
          'type': 'update',
        };

        const result = await SaveSummaryCallLog(input);
        
        if (result && result.output && result.output.result === 'Success') {
          showSuccessToast("Document downloaded and saved successfully");
        } else {
          throw new Error(result?.output?.message || "Failed to save summary");
        }
      } catch (error) {
        console.error("API Error:", error);
        showErrorToast(error.message || "Failed to complete download process");
      } finally {
        dismissLoader();
      }
    // }

  } catch (error) {
    console.error("Error in downloadSummary:", error);
    showErrorToast("Failed to download the document");
  }
};

const aiIPDLogPreview = (data) => {
  console.log('data ailogview', data);
  if (data) {
    setAiDischargeResponse(data?.aiinput || data); // Set the data first
    // Use a timeout to ensure state is updated before opening modal
    setTimeout(() => {
      previewModal.current.openModal();
    }, 200);
  }
};

// ---------------------------------------------new formatting functions --------------------------

  // Format Patient Information
const formatPatientInfo = (patientInfo) => {
  if (!patientInfo) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  return `Name: ${formatValue(patientInfo.name)}
Age: ${formatValue(patientInfo.age)}
Sex: ${formatValue(patientInfo.sex)}
Mobile: ${formatValue(patientInfo.phone)}
UHID: ${formatValue(patientInfo.uhid)}
Mrn: ${formatValue(patientInfo.mrn)}
Registration No: ${formatValue(patientInfo.registration_no)}
Panel: ${formatValue(patientInfo.panel_name)}
Consultant: ${formatValue(patientInfo.consultant)}`;
};

// Format Admission Details
const formatAdmissionDetails = (admissionDetails) => {
  if (!admissionDetails) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  return `Admitted On: ${formatValue(admissionDetails.admitted_on)}
Discharge Date: ${formatValue(admissionDetails.discharge_date)}`;
};

// Format Diagnosis
const formatDiagnosis = (diagnosis) => {
  if (!diagnosis) return "";
  let result = "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  if (diagnosis.provisional && diagnosis.provisional !== "None") {
    result += `Provisional Diagnosis: ${formatValue(diagnosis.provisional)}\n`;
  }
  if (diagnosis.final && diagnosis.final.length > 0) {
    const validDiagnosis = diagnosis.final.filter(dx => dx !== "None");
    if (validDiagnosis.length > 0) {
      result += "Final Diagnosis:\n";
      validDiagnosis.forEach((dx, index) => {
        result += `${index + 1}. ${dx}\n`;
      });
    }
  }
  return result || "";
};

// Format Presenting Complaints
const formatComplaints = (complaints) => {
  if (!complaints || !Array.isArray(complaints)) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  const validComplaints = complaints.filter(complaint => 
    complaint.description !== "None" || complaint.onset !== "None"
  );
  
  if (validComplaints.length === 0) return "";
  
  return validComplaints.map(complaint => 
    `${formatValue(complaint.description)}${complaint.onset !== "None" ? ` - Onset: ${formatValue(complaint.onset)}` : ''}`
  ).filter(line => line.trim() !== '').join('\n');
};

// Format Clinical Findings
const formatClinicalFindings = (clinicalFindings) => {
  if (!clinicalFindings) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  let result = "";
  
  // General Condition
  if (clinicalFindings.general_condition && clinicalFindings.general_condition !== "None") {
    result += `General Condition: ${formatValue(clinicalFindings.general_condition)}\n\n`;
  }
  
  // Admission Vitals - filter out "None" values
  if (clinicalFindings.admission_vitals && clinicalFindings.admission_vitals.length > 0) {
    const validVitals = clinicalFindings.admission_vitals.filter(vital => 
      vital.value !== "None" && vital.name !== "None"
    );
    if (validVitals.length > 0) {
      result += "Admission Vitals:\n";
      validVitals.forEach(vital => {
        result += `- ${formatValue(vital.name)}: ${formatValue(vital.value)} ${formatValue(vital.unit)}\n`;
      });
      result += "\n";
    }
  }
  
  // Discharge Vitals - filter out "None" values
  if (clinicalFindings.discharge_vitals && clinicalFindings.discharge_vitals.length > 0) {
    const validVitals = clinicalFindings.discharge_vitals.filter(vital => 
      vital.value !== "None" && vital.name !== "None"
    );
    if (validVitals.length > 0) {
      result += "Discharge Vitals:\n";
      validVitals.forEach(vital => {
        result += `- ${formatValue(vital.name)}: ${formatValue(vital.value)} ${formatValue(vital.unit)}\n`;
      });
      result += "\n";
    }
  }
  
  // Systemic Examination - filter out "None" values
  if (clinicalFindings.systemic_examination && clinicalFindings.systemic_examination.length > 0) {
    const validExams = clinicalFindings.systemic_examination.filter(exam => 
      exam.finding !== "None" && exam.system !== "None"
    );
    if (validExams.length > 0) {
      result += "Systemic Examination:\n";
      validExams.forEach(exam => {
        result += `- ${formatValue(exam.system)}: ${formatValue(exam.finding)}\n`;
      });
    }
  }
  
  return result.trim();
};

// Format History
const formatHistory = (history) => {
  if (!history) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  let result = "";
  
  // Personal History
  if (history.personal_history && history.personal_history.length > 0) {
    const validHistory = history.personal_history.filter(item => item !== "None");
    if (validHistory.length > 0) {
      result += "Personal History:\n";
      validHistory.forEach(item => {
        result += `- ${item}\n`;
      });
      result += "\n";
    }
  }
  
  // Past Medical History
  if (history.past_medical_history && history.past_medical_history.length > 0) {
    const validHistory = history.past_medical_history.filter(item => item !== "None");
    if (validHistory.length > 0) {
      result += "Past Medical History:\n";
      validHistory.forEach(item => {
        result += `- ${item}\n`;
      });
      result += "\n";
    }
  }
  
  // Past Surgical History
  if (history.past_surgical_history && history.past_surgical_history.length > 0) {
    const validHistory = history.past_surgical_history.filter(item => item !== "None");
    if (validHistory.length > 0) {
      result += "Past Surgical History:\n";
      validHistory.forEach(item => {
        result += `- ${item}\n`;
      });
      result += "\n";
    }
  }
  
  // Chronic Medications
  if (history.chronic_medications && history.chronic_medications.length > 0) {
    const validMeds = history.chronic_medications.filter(med => med !== "None");
    if (validMeds.length > 0) {
      result += "Chronic Medications:\n";
      validMeds.forEach(med => {
        result += `- ${med}\n`;
      });
    }
  }
  
  return result.trim();
};

// Format Investigations
const formatInvestigations = (investigations) => {
  if (!investigations || !Array.isArray(investigations)) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  const validInvestigations = investigations.filter(inv => 
    inv.value !== "None" && inv.name !== "None"
  );
  
  if (validInvestigations.length === 0) return "";
  
  return validInvestigations.map(inv => 
    `${formatValue(inv.name)}: ${formatValue(inv.value)} ${formatValue(inv.unit)}`
  ).join('\n');
};

// Format Procedures
const formatProcedures = (procedures) => {
  if (!procedures || !Array.isArray(procedures)) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  const validProcedures = procedures.filter(proc => 
    proc.name !== "None" && proc.name !== ""
  );
  
  if (validProcedures.length === 0) return "";
  
  return validProcedures.map(proc => 
    `${formatValue(proc.name)}${proc.date && proc.date !== "None" ? ` - ${formatValue(proc.date)}` : ''}${proc.details && proc.details !== "None" ? `\n${formatValue(proc.details)}` : ''}`
  ).filter(line => line.trim() !== '').join('\n\n');
};

// Format Hospital Course
const formatHospitalCourse = (hospitalCourse) => {
  if (!hospitalCourse) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  let result = "";
  
  // Summary
  if (hospitalCourse.summary && hospitalCourse.summary !== "None") {
    result += `Summary: ${formatValue(hospitalCourse.summary)}\n\n`;
  }
  
  // Interventions
  if (hospitalCourse.interventions && hospitalCourse.interventions.length > 0) {
    const validInterventions = hospitalCourse.interventions.filter(intervention => 
      intervention.name !== "None" && intervention.notes !== "None"
    );
    if (validInterventions.length > 0) {
      result += "Interventions:\n";
      validInterventions.forEach(intervention => {
        result += `- ${formatValue(intervention.name)}: ${formatValue(intervention.notes)}\n`;
      });
    }
  }
  
  return result.trim();
};

// Format Medications
const formatMedications = (medications) => {
  if (!medications || !Array.isArray(medications)) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  const validMedications = medications.filter(med => 
    med.name !== "None" && med.name !== ""
  );
  
  if (validMedications.length === 0) return "";
  
  return validMedications.map(med => {
    const parts = [
      formatValue(med.name),
      formatValue(med.dose),
      formatValue(med.frequency),
      formatValue(med.route),
      med.duration && med.duration !== "None" ? `for ${formatValue(med.duration)}` : "",
      med.timing && med.timing !== "None" ? `(${formatValue(med.timing)})` : ""
    ].filter(part => part !== "").join(' ');
    
    return parts.trim();
  }).filter(line => line.trim() !== '').join('\n');
};

// Format Instructions
const formatInstructions = (instructions) => {
  if (!instructions) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  let result = "";
  
  // To Do
  if (instructions.to_do && instructions.to_do.length > 0) {
    const validToDo = instructions.to_do.filter(item => item !== "None");
    if (validToDo.length > 0) {
      result += "To Do:\n";
      validToDo.forEach(item => {
        result += `- ${item}\n`;
      });
      result += "\n";
    }
  }
  
  // Not To Do
  if (instructions.not_to_do && instructions.not_to_do.length > 0) {
    const validNotToDo = instructions.not_to_do.filter(item => item !== "None");
    if (validNotToDo.length > 0) {
      result += "Not To Do:\n";
      validNotToDo.forEach(item => {
        result += `- ${item}\n`;
      });
    }
  }
  
  return result.trim();
};

// Format Follow Up Plan
const formatFollowUpPlan = (followUpPlan) => {
  if (!followUpPlan) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  const parts = [
    followUpPlan.follow_up_after_days && followUpPlan.follow_up_after_days !== "None" ? `Follow up after: ${formatValue(followUpPlan.follow_up_after_days)} days` : "",
    followUpPlan.doctor && followUpPlan.doctor !== "None" ? `Doctor: ${formatValue(followUpPlan.doctor)}` : "",
    followUpPlan.location && followUpPlan.location !== "None" ? `Location: ${formatValue(followUpPlan.location)}` : "",
    followUpPlan.contact && followUpPlan.contact !== "None" ? `Contact: ${formatValue(followUpPlan.contact)}` : "",
    followUpPlan.emergency_contacts && followUpPlan.emergency_contacts.length > 0 && followUpPlan.emergency_contacts.some(contact => contact !== "None") 
      ? `Emergency Contacts: ${followUpPlan.emergency_contacts.filter(contact => contact !== "None").join(', ')}` 
      : ""
  ].filter(part => part !== "").join('\n');
  
  return parts.trim();
};

// Add this helper function to format admission dates
const formatAdmissionDate = (dateString) => {
  if (!dateString) return "N/A";
  
  try {
    // Extract date part from strings like "8th Oct, 2025 at 6:59 p.m."
    const match = dateString.match(/(\d+(?:st|nd|rd|th)?\s+(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*,?\s+\d{4})/i);
    if (match) {
      return match[1].replace(/(\d+)(st|nd|rd|th)/, '$1'); // Remove ordinal suffixes
    }
    
    // Fallback: try to parse as Date
    const date = new Date(dateString);
    if (!isNaN(date.getTime())) {
      return moment(date).format("DD MMM YY");
    }
    
    return "N/A";
  } catch (error) {
    console.error("Error formatting date:", error);
    return "N/A";
  }
};
  
// Helper function to format values - show empty string instead of hiding
const formatValue = (value) => {
  if (value === "None" || value === "N/A" || value === null || value === undefined) {
    return "";
  }
  return String(value).trim();
};

// Helper function to format key names
const formatAttributeKey = (key) => {
  return key.split('_').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1)
  ).join(' ');
};

      return (
        <>
        {isLoading && <Loader />}
          <Box w="100%" display={{base: "none", lg: "block"}}>
             <Box pos='sticky' p='1rem 1.5rem' alignItems='center' top='0' zIndex='999' bg='white' borderBottom='1px solid #E6E7E9' display="flex" justifyContent="space-between" mb="10px">
                        <Text fontWeight='600'>Discharge Summary Notes</Text>
                        {/* <PrimaryButton
                          fontSize="14px"
                          variant="mdBtn"
                          btnIcon="/assets/imgs/add.png"
                          buttonText="Add ROS"
                        //   onClick={addROSData}
                          // isDisabled={actionAccessPatients?.create ? false : true}
                        /> */}
                      </Box>
            <Box w="100%">

              <Flex>
  <Box w="calc(100vw - 6.5rem)">
    <Box w="100%">
      <>
        {/* <Box w='100%' p="1.5rem 2rem" maxH="calc(100vh - 310px)" overflowY="auto" className="dischargeContainer"> */}
        <Box w='100%' p="1.5rem 2rem" maxH="calc(100vh - 70px)" overflowY="auto" className="dischargeContainer">
          <SimpleGrid 
            columns={{ 
              base: 1, 
              md: 2,
              lg: dischargeSummary && dischargeSummary.length == 0 ? 1 : 2, 
              xl: dischargeSummary && dischargeSummary.length == 0 ? 1 : 2 
            }} 
            spacing="1rem" 
          >
            {dischargeSummary && dischargeSummary.length > 0 ? (
              dischargeSummary.map((item, index) => {
                const patientInfo = item.aiinput?.patient_info || {};
                const diagnosis = item.aiinput?.diagnosis || {};
                const admissionDetails = item.aiinput?.admission_details || {};
                const specialities = item.doctorqualification?.map(q => q.degreename) || [];
                const primaryDiagnosis = diagnosis.final?.[0] || diagnosis.provisional || "Not specified";
                
                return (
                  <DoctorCard
                    key={index}
                    hasFooter={false}
                    cardBody={
                      <>
                        {/* Header Section */}
                        <Box display="flex" justifyContent="space-between" w="100%" alignItems="flex-start" mb="6px">
                          <Box>
                            <Text fontSize="0.875rem" fontWeight="600" color="#061027" mb="2px">
                              Discharge Summary
                            </Text>
                            <Badge 
                              colorScheme={item.iscomplete === 1 ? "green" : "orange"} 
                              fontSize="0.65rem" 
                            >
                              {item.iscomplete === 1 ? "COMPLETED" : "DRAFT"}
                            </Badge>
                          </Box>
                          <Box textAlign="right">
                            <Text fontSize="0.75rem" fontWeight="600" color="#061027">
                              {formatDate_Do_MMM_YYYY_Time(item.createddate)}
                            </Text>
                            <Text fontSize="0.7rem" color="#666" mt="2px">
                              {item.guid ? `ID: ${item.guid}` : ""}
                            </Text>
                          </Box>
                        </Box>

                        {/* Patient Information - Single Line */}
                        <Box mb="1px">
                          <Text fontSize="0.75rem" fontWeight="600" color="#061027" display="inline" mr="6px">
                            Patient:
                          </Text>
                          <Text fontSize="0.75rem" color="#666" display="inline">
                            {patientInfo.name || "N/A"} • {patientInfo.age || "N/A"} • {patientInfo.sex || "N/A"}
                            {patientInfo.uhid && ` • UHID: ${patientInfo.uhid}`}
                          </Text>
                        </Box>

                        {/* Consultant & Admission Period - Single Line */}
                        <Box mb="1px" display="flex" justifyContent="space-between" alignItems="center">
                          <Box flex="1">
                            <Text fontSize="0.75rem" fontWeight="600" color="#061027" display="inline" mr="6px">
                              Consultant:
                            </Text>
                            <Text fontSize="0.75rem" color="#666" display="inline">
                              {item.doctorname}
                              {specialities.length > 0 && ` • ${specialities[0]}`}
                              {specialities.length > 1 && "..."}
                            </Text>
                          </Box>
                          {(admissionDetails.admitted_on || admissionDetails.discharge_date) && (
                            <Box textAlign="right" ml="10px" flexShrink={0}>
                              <Text fontSize="0.75rem" fontWeight="600" color="#061027" display="inline" mr="4px">
                                Stay:
                              </Text>
                              <Text fontSize="0.7rem" color="#666" display="inline">
                                {admissionDetails.admitted_on ? formatAdmissionDate(admissionDetails.admitted_on) : "N/A"} 
                                {" - "}
                                {admissionDetails.discharge_date ? formatAdmissionDate(admissionDetails.discharge_date) : "N/A"}
                              </Text>
                            </Box>
                          )}
                        </Box>

                        {/* Primary Diagnosis - Single Line */}
                        <Box mb="12px">
                          <Text fontSize="0.75rem" fontWeight="600" color="#061027" display="inline" mr="6px">
                            Diagnosis:
                          </Text>
                          <Text fontSize="0.75rem" color="#666" display="inline" noOfLines={1}>
                            {primaryDiagnosis}
                          </Text>
                        </Box>

                        {/* Compact Audio Player Section */}
                        {item.audiourl && (
                          <Box mt="8px" mb="8px" p="6px" bg="blue.50" borderRadius="6px">
                            <Box display="flex" alignItems="center" justifyContent="space-between" mb="4px">
                              <Text fontSize="0.7rem" fontWeight="600" color="#061027">
                                🎧 Recorded Audio
                              </Text>
                              <Box
                                as="button"
                                fontSize="0.6rem"
                                color="blue.600"
                                fontWeight="500"
                                onClick={() => {
                                  // Add play/pause functionality if needed
                                  const audio = audioPlayerRef.current;
                                  if (audio) {
                                    audio.paused ? audio.play() : audio.pause();
                                  }
                                }}
                              >
                                Play
                              </Box>
                            </Box>
                            <audio
                              ref={audioPlayerRef}
                              src={item.imagepath + item.audiourl}
                              controls
                              style={{ 
                                width: "100%", 
                                height: "30px",
                                borderRadius: "4px"
                              }}
                            />
                          </Box>
                        )}

                        {/* Preview Buttons */}
                        {/* OPD Discharge */}
                        {item.iscomplete == 1 && item.ailog != null && (
                          <Box w="100%" mt="8px">
                            <Box
                              as="button"
                              w="100%"
                              border="1px solid #E6E7E9"
                              p="6px"
                              borderRadius="6px"
                              height="36px"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              bg="white"
                              _hover={{ bg: "gray.50" }}
                              onClick={() => aiLogPreview(item.ailog)}
                            >
                              <Box display="flex" fontSize="12px" flexDirection="column" justifyContent="center" fontWeight="500">
                                Preview
                              </Box>
                            </Box>
                          </Box>
                        )}

                        {/* IPD Discharge */}
                        {item.iscomplete == 1 && item.ailog == null && (
                          <Box w="100%" mt="8px">
                            <Box
                              as="button"
                              w="100%"
                              border="1px solid #E6E7E9"
                              p="6px"
                              borderRadius="6px"
                              height="36px"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              bg="white"
                              _hover={{ bg: "gray.50" }}
                              onClick={() => aiIPDLogPreview(item.aiinput)}
                            >
                              <Box display="flex" fontSize="12px" flexDirection="column" justifyContent="center" fontWeight="500">
                                Preview
                              </Box>
                            </Box>
                          </Box>
                        )}

                        {/* In Process Status */}
                        {item.iscomplete == 0 && item.issingledocument != 1 && (
                          <Box mt="8px" p="4px" bg="orange.50" borderRadius="4px">
                            <Text fontSize="0.7rem" fontWeight="600" color="orange.600" textAlign="center">
                              ⏳ Processing...
                            </Text>
                          </Box>
                        )}
                      </>
                    }
                  />
                );
              })
            ) : (
              <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" height="calc(100vh - 300px)" width="100%">
                <Image boxSize="64px" opacity="0.5" src="/assets/svgs/prescriptions.svg" />
                <Text>No Discharge summary Notes found</Text>
              </Box>
            )}
          </SimpleGrid>
        </Box>
      </>
    </Box>
  </Box>
</Flex>
           {/* <Flex>
  <Box w="calc(100vw - 6.5rem)">
    <Box w="100%">
      <>
        <Box w='100%' p="1.5rem 2rem" maxH="calc(100vh - 310px)" overflowY="auto" className="dischargeContainer">
          <SimpleGrid 
            columns={{ 
              base: 1, 
              md: 2,
              lg: dischargeSummary && dischargeSummary.length == 0 ? 1 : 2, 
              xl: dischargeSummary && dischargeSummary.length == 0 ? 1 : 2 
            }} 
            spacing="1rem" 
          >
            {dischargeSummary && dischargeSummary.length > 0 ? (
              dischargeSummary.map((item, index) => {
                const patientInfo = item.aiinput?.patient_info || {};
                const diagnosis = item.aiinput?.diagnosis || {};
                const admissionDetails = item.aiinput?.admission_details || {};
                const specialities = item.doctorqualification?.map(q => q.degreename) || [];
                const primaryDiagnosis = diagnosis.final?.[0] || diagnosis.provisional || "Not specified";
                
                return (
                  <DoctorCard
                    key={index}
                    hasFooter={false}
                    cardBody={
                      <>
                        Header Section
                        <Box display="flex" justifyContent="space-between" w="100%" alignItems="flex-start" mb="6px">
                          <Box>
                            <Text fontSize="0.875rem" fontWeight="600" color="#061027" mb="2px">
                              Discharge Summary
                            </Text>
                            <Badge 
                              colorScheme={item.iscomplete === 1 ? "green" : "orange"} 
                              fontSize="0.65rem" 
                            >
                              {item.iscomplete === 1 ? "COMPLETED" : "DRAFT"}
                            </Badge>
                          </Box>
                          <Box textAlign="right">
                            <Text fontSize="0.75rem" fontWeight="600" color="#061027">
                              {formatDate_Do_MMM_YYYY_Time(item.createddate)}
                            </Text>
                            <Text fontSize="0.7rem" color="#666" mt="2px">
                              {item.guid ? `ID: ${item.guid}` : ""}
                            </Text>
                          </Box>
                        </Box>

                        Patient Information - Single Line
                        <Box mb="1px">
                          <Text fontSize="0.75rem" fontWeight="600" color="#061027" display="inline" mr="6px">
                            Patient:
                          </Text>
                          <Text fontSize="0.75rem" color="#666" display="inline">
                            {patientInfo.name || "N/A"} • {patientInfo.age || "N/A"} • {patientInfo.sex || "N/A"}
                            {patientInfo.uhid && ` • UHID: ${patientInfo.uhid}`}
                          </Text>
                        </Box>

                        Consultant & Admission Period - Single Line
                        <Box mb="1px" display="flex" justifyContent="space-between" alignItems="center">
                          <Box flex="1">
                            <Text fontSize="0.75rem" fontWeight="600" color="#061027" display="inline" mr="6px">
                              Consultant:
                            </Text>
                            <Text fontSize="0.75rem" color="#666" display="inline">
                              {item.doctorname}
                              {specialities.length > 0 && ` • ${specialities[0]}`}
                              {specialities.length > 1 && "..."}
                            </Text>
                          </Box>
                          {(admissionDetails.admitted_on || admissionDetails.discharge_date) && (
                            <Box textAlign="right" ml="10px" flexShrink={0}>
                              <Text fontSize="0.75rem" fontWeight="600" color="#061027" display="inline" mr="4px">
                                Stay:
                              </Text>
                              <Text fontSize="0.7rem" color="#666" display="inline">
                                {admissionDetails.admitted_on ? formatAdmissionDate(admissionDetails.admitted_on) : "N/A"} 
                                {" - "}
                                {admissionDetails.discharge_date ? formatAdmissionDate(admissionDetails.discharge_date) : "N/A"}
                              </Text>
                            </Box>
                          )}
                        </Box>

                        Primary Diagnosis - Single Line
                        <Box mb="12px">
                          <Text fontSize="0.75rem" fontWeight="600" color="#061027" display="inline" mr="6px">
                            Diagnosis:
                          </Text>
                          <Text fontSize="0.75rem" color="#666" display="inline" noOfLines={1}>
                            {primaryDiagnosis}
                          </Text>
                        </Box>

                        Compact Audio Player Section
                        {item.audiourl && (
                          <Box mt="8px" mb="8px" p="6px" bg="blue.50" borderRadius="6px">
                            <Box display="flex" alignItems="center" justifyContent="space-between" mb="4px">
                              <Text fontSize="0.7rem" fontWeight="600" color="#061027">
                                🎧 Recorded Audio
                              </Text>
                              <Box
                                as="button"
                                fontSize="0.6rem"
                                color="blue.600"
                                fontWeight="500"
                                onClick={() => {
                                  // Add play/pause functionality if needed
                                  const audio = audioPlayerRef.current;
                                  if (audio) {
                                    audio.paused ? audio.play() : audio.pause();
                                  }
                                }}
                              >
                                Play
                              </Box>
                            </Box>
                            <audio
                              ref={audioPlayerRef}
                              src={item.imagepath + item.audiourl}
                              controls
                              style={{ 
                                width: "100%", 
                                height: "30px",
                                borderRadius: "4px"
                              }}
                            />
                          </Box>
                        )}

                        Preview Buttons
                        OPD Discharge
                        {item.iscomplete == 1 && item.ailog != null && (
                          <Box w="100%" mt="8px">
                            <Box
                              as="button"
                              w="100%"
                              border="1px solid #E6E7E9"
                              p="6px"
                              borderRadius="6px"
                              height="36px"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              bg="white"
                              _hover={{ bg: "gray.50" }}
                              onClick={() => aiLogPreview(item.ailog)}
                            >
                              <Box display="flex" fontSize="12px" flexDirection="column" justifyContent="center" fontWeight="500">
                                Preview
                              </Box>
                            </Box>
                          </Box>
                        )}

                        IPD Discharge
                        {item.iscomplete == 1 && item.ailog == null && (
                          <Box w="100%" mt="8px">
                            <Box
                              as="button"
                              w="100%"
                              border="1px solid #E6E7E9"
                              p="6px"
                              borderRadius="6px"
                              height="36px"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              bg="white"
                              _hover={{ bg: "gray.50" }}
                              onClick={() => aiIPDLogPreview(item.aiinput)}
                            >
                              <Box display="flex" fontSize="12px" flexDirection="column" justifyContent="center" fontWeight="500">
                                Preview
                              </Box>
                            </Box>
                          </Box>
                        )}

                        In Process Status
                        {item.iscomplete == 0 && item.issingledocument != 1 && (
                          <Box mt="8px" p="4px" bg="orange.50" borderRadius="4px">
                            <Text fontSize="0.7rem" fontWeight="600" color="orange.600" textAlign="center">
                              ⏳ Processing...
                            </Text>
                          </Box>
                        )}
                      </>
                    }
                  />
                );
              })
            ) : (
              <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" height="calc(100vh - 300px)" width="100%">
                <Image boxSize="64px" opacity="0.5" src="/assets/svgs/prescriptions.svg" />
                <Text>No Discharge summary Notes found</Text>
              </Box>
            )}
          </SimpleGrid>
        </Box>
      </>
    </Box>
  </Box>
</Flex> */}
            </Box>
          </Box>


<DynamicModal
  ref={previewModal}
  modalHeader="Aira: IPD Discharge Notes"
  modalWidth={"50vw"}
  hasFooter={false}
  modalBody={
    <>
      <Box
        width='100%'
        overflowY="scroll"
        sx={{
          "::-webkit-scrollbar": {
            display: "none",
          },
          msOverflowStyle: "none",
          scrollbarWidth: "none",
        }}
      >
        <>
          <Tabs>
            <TabList height={"3rem"} borderBottom={"1px solid gray"}>
              <Tab
                onClick={() => handleTabChange("discharge")}
                _selected={{ color: "black", borderBottom: "2px solid black" }}
                fontSize={{ base: "12px", lg: "initial" }}
              >
                Discharge Summary
              </Tab>
              <Tab
                onClick={() => handleTabChange("share")}
                _selected={{ color: "black", borderBottom: "2px solid black" }}
                fontSize={{ base: "12px", lg: "initial" }}
              >
                Share Details
              </Tab>
            </TabList>

            <TabPanels
              height="calc(77vh - 2.5rem)"
              overflowY="auto"
              mt="2rem"
              sx={{
                "::-webkit-scrollbar": { display: "none" },
                msOverflowStyle: "none",
                scrollbarWidth: "none"
              }}
            >
              {/* Discharge Summary Tab */}
              <TabPanel p={{ base: "0" }}>
                <Flex w='100%' gap='1rem'>
                  {/* Patient Information */}
                  <Box w='100%' mb={4}>
                    <Flex justifyContent="space-between" alignItems="center">
                      <Heading as="h4" size="md">Patient Information</Heading>
                      <Spacer />
                      <IconButton
                        aria-label="Copy Patient Info"
                        icon={<CopyIcon />}
                        onClick={() => copyToClipboard(formatPatientInfo(aiDischargeResponse?.patient_info))}
                        variant="ghost"
                      />
                    </Flex>
                    <Textarea
                      value={editableSections.patientInfo || formatPatientInfo(aiDischargeResponse?.patient_info)}
                      isReadOnly // Added read-only
                      resize="none"
                      h='100px'
                      placeholder="Enter patient information..."
                    />
                  </Box>
      
                  {/* Admission Details */}
                  <Box w='100%' mb={4}>
                    <Flex justifyContent="space-between" alignItems="center">
                      <Heading as="h4" size="md">Admission Details</Heading>
                      <Spacer />
                      <IconButton
                        aria-label="Copy Admission Details"
                        icon={<CopyIcon />}
                        onClick={() => copyToClipboard(formatAdmissionDetails(aiDischargeResponse?.admission_details))}
                        variant="ghost"
                      />
                    </Flex>
                    <Textarea
                      value={editableSections.admissionDetails || formatAdmissionDetails(aiDischargeResponse?.admission_details)}
                      isReadOnly // Added read-only
                      resize="none"
                      h='100px'
                      placeholder="Admitted: [date]\nDischarged: [date]"
                    />
                  </Box>
                </Flex>
      
                {/* Diagnosis */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.diagnosis == 1 && ( */}
                <Box mt={8} mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Diagnosis</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Diagnosis"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatDiagnosis(aiDischargeResponse?.diagnosis))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.diagnosis || formatDiagnosis(aiDischargeResponse?.diagnosis)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='100px'
                    placeholder="Enter one diagnosis per line..."
                  />
                </Box>
                {/* )} */}
      
                {/* Presenting Complaints */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.complaints == 1 && ( */}
                <Box my={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Presenting Complaints</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Presenting Complaints"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatComplaints(aiDischargeResponse?.presenting_complaints))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.presentingComplaints || formatComplaints(aiDischargeResponse?.presenting_complaints)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='100px'
                    placeholder="Description - Onset (one per line)"
                  />
                </Box>
                {/* )} */}
      
                {/* Clinical Findings */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.findings == 1 && ( */}
                <Box my={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Clinical Findings</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Clinical Findings"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatClinicalFindings(aiDischargeResponse?.clinical_findings))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.clinicalFindings || formatClinicalFindings(aiDischargeResponse?.clinical_findings)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='200px'
                    placeholder="General Condition: [text]\nVitals:\n- [name]: [value] [unit]\nSystemic Exam:\n- [system]: [finding]"
                  />
                </Box>
                {/* )} */}
      
                {/* History */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.history == 1 && ( */}
                <Box mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">History</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy History"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatHistory(aiDischargeResponse?.history))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.history || formatHistory(aiDischargeResponse?.history)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='150px'
                    placeholder="Personal History:\n- [history]\n\nPast Medical History:\n- [history]\n\nPast Surgical History:\n- [history]\n\nChronic Medications:\n- [medication]"
                  />
                </Box>
                {/* )} */}
      
                {/* Investigations */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.investigation == 1 && ( */}
                <Box mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Investigations</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Investigations"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatInvestigations(aiDischargeResponse?.investigations))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.investigations || formatInvestigations(aiDischargeResponse?.investigations)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='100px'
                    placeholder="[Name]: [Value] [Unit]\nExample:\nHemoglobin: 9.6 g/dL\nBlood Urea: 68 mg/dL"
                  />
                </Box>
                {/* )} */}
      
                {/* Procedures */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.procedure == 1 && ( */}
                <Box mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Procedures</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Procedures"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatProcedures(aiDischargeResponse?.procedures))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.procedures || formatProcedures(aiDischargeResponse?.procedures)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='100px'
                    placeholder="[Procedure Name] - [Date]\n[Details]\n\nExample:\nECG - 10/07/2025\nNormal sinus rhythm"
                  />
                </Box>
                {/* )} */}
      
                {/* Hospital Course */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.course == 1 && ( */}
                <Box mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Hospital Course</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Hospital Course"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatHospitalCourse(aiDischargeResponse?.hospital_course))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.hospitalCourse || formatHospitalCourse(aiDischargeResponse?.hospital_course)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='120px'
                    placeholder="Summary: [text]\nInterventions:\n- [name]: [notes]"
                  />
                </Box>
                {/* )} */}
      
                {/* Discharge Medications */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.medication == 1 && ( */}
                <Box mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Discharge Medications</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Discharge Medications"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatMedications(aiDischargeResponse?.medications_on_discharge))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.dischargeMeds || formatMedications(aiDischargeResponse?.medications_on_discharge)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='120px'
                    placeholder="[Name] [Dose] [Frequency] [Route]\nExample:\nTelma 40 40mg once daily oral"
                  />
                </Box>
                {/* )} */}
      
                {/* Instructions */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.instruction == 1 && ( */}
                <Box mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Instructions</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Instructions"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatInstructions(aiDischargeResponse?.instructions))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.instructions || formatInstructions(aiDischargeResponse?.instructions)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='120px'
                    placeholder="To Do:\n- [instruction]\nNot To Do:\n- [instruction]"
                  />
                </Box>
                {/* )} */}
      
                {/* Follow Up Plan */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.diagnosis == 1 && ( */}
                <Box mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Follow Up Plan</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Follow Up Plan"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatFollowUpPlan(aiDischargeResponse?.follow_up_plan))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.followUpPlan || formatFollowUpPlan(aiDischargeResponse?.follow_up_plan)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='100px'
                    placeholder="Follow up after: [days] days\nLocation: [location]\nDoctor: [doctor]\nContact: [contact]"
                  />
                </Box>
                {/* )} */}

                {/* Dynamic Custom Attributes Section */}
{aiDischargeResponse?.custom_attributes && Object.keys(aiDischargeResponse.custom_attributes).length > 0 && (
  <Box mb={4}>
    <Heading as="h4" size="md" mb={4} color="gray.600">
      {/* Additional Information */}
      Dynamic Attributes
    </Heading>
    
    {Object.entries(aiDischargeResponse.custom_attributes).map(([key, value]) => {
      const formattedKey = formatAttributeKey(key);
      const formattedValue = formatValue(value);
      
      return (
        <Box key={key} mb={4}>
          <Flex justifyContent="space-between" alignItems="center">
            <Heading as="h5" size="sm">{formattedKey}</Heading>
            <Spacer />
            <IconButton
              aria-label={`Copy ${formattedKey}`}
              icon={<CopyIcon />}
              onClick={() => copyToClipboard(formattedValue)}
              variant="ghost"
              size="sm"
            />
            <IconButton
              aria-label={`Clear ${formattedKey}`}
              icon={<CgRemove />}
              onClick={() => setEditableSections(prev => ({
                ...prev,
                [key]: ""
              }))}
              variant="ghost"
              size="sm"
            />
          </Flex>
          <Textarea
            value={editableSections[key] !== undefined ? editableSections[key] : formattedValue}
            onChange={(e) => setEditableSections(prev => ({
              ...prev,
              [key]: e.target.value
            }))}
            resize="none"
            h='100px'
            placeholder={`Enter ${formattedKey.toLowerCase()}...`}
          />
        </Box>
      );
    })}
  </Box>
)}
      
                <Text fontWeight="bold" color="black" fontSize="sm">
                  AIRA strives to be as accurate as possible, but occasional
                  errors may occur. Please verify its responses to ensure the
                  information meets your needs.
                </Text>
              </TabPanel>

              {/* Share Details Tab */}
              <TabPanel p={{ base: "0" }}>
                <Box mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Email Information</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Email"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(shareReportDoctorEmail)}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={shareReportDoctorEmail}
                    isReadOnly // Added read-only
                    resize="none"
                  />
                  <Heading as="h4" size="md" mt={6}>Details:</Heading>
                  <Stack spacing={2} mt={2}>
                    <Checkbox
                      isChecked={shareChatSummary}
                      isReadOnly // Added read-only for checkboxes
                    >
                      Share chat summary
                    </Checkbox>
                    <Checkbox
                      isChecked={shareChatHistory}
                      isReadOnly // Added read-only for checkboxes
                    >
                      Share chat history
                    </Checkbox>
                    <Checkbox
                      isChecked={shareDoctorNotes}
                      isReadOnly // Added read-only for checkboxes
                    >
                      Share Discharge Summary Notes
                    </Checkbox>
                  </Stack>
                  <Button
                    className="primary-button-icon" 
                    sx={{
                      h: "2.5rem",
                      w: "8rem",
                      p: "1rem",
                      m: "0",
                      mr:'1rem',
                      mt: "48px",
                      bg: COLORS.PRIMARY_GRADIENT,
                      color: COLORS.PRIMARY_WHITE,
                      _hover: { bg: COLORS.PRIMARY_COLOR },
                    }}
                  >
                    <Box className="icon-img" as="span" sx={{ mr: "0.5rem" }}>
                      <Image src="/assets/imgs/email-icon.png" h={"24px"} w={"24px"} />
                    </Box>
                    <Text>Share</Text>
                  </Button>
                  <Button
                    className="primary-button-icon" 
                    onClick={downloadSummary}
                    sx={{
                      h: "2.5rem",
                      w: "8rem",
                      p: "1rem",
                      m: "0",
                      mt: "48px",
                      bg: COLORS.PRIMARY_GRADIENT,
                      color: COLORS.PRIMARY_WHITE,
                      _hover: { bg: COLORS.PRIMARY_COLOR },
                    }}
                  >
                    <Box className="icon-img" as="span" sx={{ mr: "0.5rem" }}>
                      <Image src="/assets/imgs/email-icon.png" h={"24px"} w={"24px"} />
                    </Box>
                    <Text>Download</Text>
                  </Button>
                </Box>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </>
      </Box>
    </>
  }
/>
        </>
      );
}

export default DischargeSummaryIPD